module.exports = __webpack_public_path__ + "img/active-past4.28554faf.jpg";